const LOG = false;
function newPropState() {
    return {
        trajectory: null,
        heldBy: null,
    };
}
function clonePropState(s) {
    const ret = newPropState();
    if (s.trajectory) {
        ret.trajectory = Object.assign({}, s.trajectory);
    }
    if (s.heldBy) {
        ret.heldBy = Object.assign({}, s.heldBy);
    }
    return ret;
}
function newPropsState() {
    return {
        nextId: 0,
        props: {},
    };
}
function clonePropsState(s) {
    const ret = {
        nextId: s.nextId,
        props: {},
    };
    Object.keys(s.props).forEach((id) => {
        const propId = id;
        ret.props[propId] = clonePropState(s.props[propId]);
    });
    return ret;
}
function newHandState() {
    return {
        catchQueue: [],
        holding: [],
        lastThrowGen: -Infinity,
    };
}
function cloneHandState(s) {
    return {
        catchQueue: [...s.catchQueue],
        holding: [...s.holding],
        lastThrowGen: s.lastThrowGen,
    };
}
function newJugglerState() {
    return { hands: [newHandState(), newHandState()] };
}
function cloneJugglerState(s) {
    return {
        hands: s.hands.map((hs) => cloneHandState(hs)),
    };
}
function allocPropToThrow(state2) {
    const propId = state2.props.nextId++;
    !LOG || console.log(`New prop in the game: ${propId}`);
    state2.props.props[propId] = newPropState();
    return propId;
}
function planThrow1ToJuggler(state, state2, pendingThrow, thr0w, j) {
    let jstate2 = state2.jugglers[j];
    for (let h = 0; h < jstate2.hands.length; h++) {
        let hstate2 = jstate2.hands[h];
        if (thr0w.cross && pendingThrow.hand === h) {
            // It's a cross, so skip throwing to the same hand.
            continue;
        }
        if (!thr0w.cross &&
            (pendingThrow.hand === h) !== (thr0w.height % 2 === 0)) {
            // Odd throws go to other hand
            continue;
        }
        // Check free spot at height
        // A height of 1 is to be placed at catchQueue[0].
        const qpos = thr0w.height - 1;
        const cq = hstate2.catchQueue[qpos];
        if (typeof cq !== "undefined" && cq.length > 0) {
            // Perhaps taken, depends on whether or not a multiplex throw
            // occurs there.
        }
        // Check able to catch beat wise
        // If hand is throwing now, then 1/3/5 beats from now it is catching.
        // If hand is catching now, then in 0/2/4 beats it is catching as well.
        if (hstate2.lastThrowGen < 0 ||
            (state2.gen - hstate2.lastThrowGen) % 2 === thr0w.height % 2) {
            !LOG ||
                console.log(`juggler ${j} plans throw of height ${thr0w.height} with one of props ${pendingThrow.propIds.join(", ")} to catch in hand ${h}`);
            return h;
        }
    }
    return null;
}
function planThrow1(state, state2, pendingThrow, thr0w) {
    let toJuggler = pendingThrow.juggler;
    if (thr0w.pass) {
        toJuggler = (pendingThrow.juggler + 1) % state.jugglers.length;
        if (typeof thr0w.passTo !== "undefined") {
            toJuggler = thr0w.passTo;
        }
    }
    let toH = planThrow1ToJuggler(state, state2, pendingThrow, thr0w, toJuggler);
    if (toH !== null) {
        return [toJuggler, toH];
    }
    throw new Error(`juggler ${pendingThrow.juggler} has no plan for throw of height ${thr0w.height} from hand ${pendingThrow.hand}`);
}
function throwProps1(state, state2, pendingThrow) {
    const plans = [];
    pendingThrow.multiplex.multiplexes.forEach((thr0w, i) => {
        if (thr0w.height === 0) {
            plans.push(null);
            return;
        }
        plans.push([
            ...planThrow1(state, state2, pendingThrow, thr0w),
            thr0w.height,
        ]);
    });
    const propIds = pendingThrow.propIds;
    pendingThrow.multiplex.multiplexes.forEach((thr0w, i) => {
        const plan = plans[i];
        if (plan === null) {
            return;
        }
        const [toJ, toH, height] = plan;
        let jstate2 = state2.jugglers[toJ];
        let hstate2 = jstate2.hands[toH];
        let cq = hstate2.catchQueue[height - 1];
        if (typeof cq === "undefined") {
            cq = [];
            hstate2.catchQueue[height - 1] = cq;
        }
        const propId = propIds.shift();
        cq.push(propId);
        state2.jugglers[pendingThrow.juggler].hands[pendingThrow.hand].lastThrowGen = state2.gen;
        const pstate2 = state2.props.props[propId];
        pstate2.heldBy = null;
        pstate2.trajectory = {
            source: { juggler: pendingThrow.juggler, hand: pendingThrow.hand },
            target: { juggler: toJ, hand: toH },
            height: height,
            thrownAtGen: state2.gen,
        };
    });
}
function throwProps(state, state2, pendingThrows) {
    pendingThrows.forEach((pt) => {
        throwProps1(state, state2, pt);
    });
}
function prepareThrowHand(state, state2, j, h, mpt) {
    const jstate2 = state2.jugglers[j];
    const hstate2 = jstate2.hands[h];
    if (state2.gen - hstate2.lastThrowGen <= 1)
        return null;
    hstate2.lastThrowGen = state2.gen;
    const propIds = [];
    mpt.multiplexes.forEach((thr0w) => {
        if (thr0w.height === 0) {
            return;
        }
        let propId;
        if (hstate2.holding.length > 0) {
            propId = hstate2.holding.shift();
        }
        else {
            propId = allocPropToThrow(state2);
        }
        propIds.push(propId);
    });
    !LOG ||
        console.log(`juggler ${j} throws props ${propIds.join(", ")} with hand ${h}`);
    return { propIds: propIds, juggler: j, hand: h, multiplex: mpt };
}
function prepareThrow(state, state2, j, b) {
    const jstate2 = state2.jugglers[j];
    if (b.beatThrows.length > 1 && jstate2.hands.length !== b.beatThrows.length) {
        throw new Error("synchronous pattern does not match hand count");
    }
    let pendingThrows = [];
    b.beatThrows.forEach((mpt, bti) => {
        // We'll need to find a free hand that can do this throw
        let thrown = false;
        for (let h = 0; h < jstate2.hands.length; h++) {
            const pt = prepareThrowHand(state, state2, j, h, mpt);
            if (!pt) {
                continue;
            }
            thrown = true;
            pendingThrows = pendingThrows.concat(pt);
            break;
        }
        if (!thrown) {
            throw new Error("no free hand to make the throw");
        }
    });
    return pendingThrows;
}
export function newState(jugglerCount) {
    const ret = [];
    for (let i = 0; i < jugglerCount; i++) {
        ret.push(newJugglerState());
    }
    return {
        props: newPropsState(),
        jugglers: ret,
        gen: -1,
    };
}
function cloneState(s) {
    return {
        props: clonePropsState(s.props),
        jugglers: s.jugglers.map((js) => cloneJugglerState(js)),
        gen: s.gen,
    };
}
function prepareThrows(state, state2, beatsPerJuggler) {
    if (beatsPerJuggler.length !== state.jugglers.length) {
        throw new Error("number of jugglers out of sync with throws per beat");
    }
    let pendingThrows = [];
    state.jugglers.forEach((jstate, j) => {
        const b = beatsPerJuggler[j];
        if (b === null) {
            return;
        }
        const pt = prepareThrow(state, state2, j, b);
        pendingThrows = pendingThrows.concat(pt);
    });
    return pendingThrows;
}
export function catchProps(state, state2) {
    state2.jugglers.forEach((jstate2, j) => {
        jstate2.hands.forEach((hstate2, h) => {
            const propsToCatch = hstate2.catchQueue.shift();
            if (typeof propsToCatch === "undefined" || !propsToCatch.length) {
                return;
            }
            !LOG || console.log(`juggler ${j} caught prop with hand ${h}`);
            hstate2.holding = hstate2.holding.concat(propsToCatch);
            const handId = { juggler: j, hand: h };
            propsToCatch.forEach((propId) => {
                state2.props.props[propId].trajectory = null;
                state2.props.props[propId].heldBy = handId;
                !LOG || console.log(state.props);
            });
        });
    });
}
export function canJugglerThrow(state, j) {
    const jstate = state.jugglers[j];
    for (const hstate of jstate.hands) {
        if (state.gen + 1 - hstate.lastThrowGen > 1) {
            return true;
        }
    }
    return false;
}
export function transitionState(state, beatsPerJuggler) {
    !LOG || console.log("STEP");
    let state2 = cloneState(state);
    state2.gen++;
    catchProps(state, state2);
    const pendingThrows = prepareThrows(state, state2, beatsPerJuggler);
    throwProps(state, state2, pendingThrows);
    // Every prop caught must have been re-thrown.
    // Without this, 654 becomes possible, but is actually [622]5[42].
    for (let propId = 0; propId < state2.props.nextId; propId++) {
        const pstate = state2.props.props[propId];
        if (pstate.heldBy) {
            throw new Error();
        }
    }
    return state2;
}
function handStateFingerprint(hstate) {
    return "dummy";
}
function jugglerStateFingerprint(jstate) {
    return jstate.hands.map((hstate) => handStateFingerprint(hstate)).join("/");
}
function propStateFingerprint(gen, propState) {
    const heldBy = propState.heldBy;
    if (heldBy) {
        return `${heldBy.juggler}@${heldBy.hand}`;
    }
    const t = propState.trajectory;
    if (t) {
        return `${t.source.juggler}@${t.source.hand}-(${t.height})->${t.target.juggler}@${t.target.hand} ${gen - t.thrownAtGen}ago`;
    }
    return "";
}
function propsStateFingerprint(state) {
    const fps = [];
    for (let propId = 0; propId < state.props.nextId; propId++) {
        const pstate = state.props.props[propId];
        const pfp = propStateFingerprint(state.gen, pstate);
        fps.push(`${propId}=${pfp}`);
    }
    return fps.join("|");
}
export function stateFingerprint(state) {
    const jfp = state.jugglers.map((js) => jugglerStateFingerprint(js)).join(",");
    const pfp = propsStateFingerprint(state);
    return `j:${jfp} props:${pfp}`;
}
function shiftHandState(hstate, dgen) {
    return Object.assign(Object.assign({}, hstate), { lastThrowGen: hstate.lastThrowGen + dgen });
}
function shiftJugglerState(jstate, dgen) {
    return Object.assign(Object.assign({}, jstate), { hands: jstate.hands.map((hstate) => shiftHandState(hstate, dgen)) });
}
function shiftPropState(pstate, dgen) {
    const pstate2 = Object.assign({}, pstate);
    if (pstate.trajectory) {
        pstate2.trajectory = Object.assign(Object.assign({}, pstate.trajectory), { thrownAtGen: pstate.trajectory.thrownAtGen + dgen });
    }
    return pstate2;
}
function shiftPropsState(pstate, dgen) {
    const pstate2 = Object.assign(Object.assign({}, pstate), { props: {} });
    for (const pidAny of Object.keys(pstate.props)) {
        const pid = pidAny;
        pstate2.props[pid] = shiftPropState(pstate.props[pid], dgen);
    }
    return pstate2;
}
export function shiftState(state, dgen) {
    const state2 = Object.assign(Object.assign({}, state), { jugglers: state.jugglers.map((jstate) => shiftJugglerState(jstate, dgen)), props: shiftPropsState(state.props, dgen), gen: state.gen + dgen });
    return state2;
}
export function isTrajectoryHolding(trajectory) {
    return (trajectory.height === 2 &&
        trajectory.source.juggler === trajectory.target.juggler &&
        trajectory.source.hand === trajectory.target.hand);
}
